import React from 'react'
import { useTranslation } from "react-i18next";

const FooterNew = () => {
  const { t } = useTranslation();
  return (
    <footer
          className="v-footer footer v-sheet theme--light footer_color"
          data-booted="true"
        >
          <div className="footer_wrapper">
            <div className="footer-container-1">
              <div className="payment-methods">
                <div className="footer-title mb-2">{t("PaymentMethods")}</div>
                <div className="d-flex flex-wrap payment-methods-icons">
                  <div
                    aria-label
                    className="v-image v-responsive footer-icon theme--light"
                  >
                    <div
                      className="v-responsive__sizer"
                      style={{ "padding-bottom": "114.815%" }}
                    />
                    <div
                      className="v-image__image v-image__image--contain"
                      style={{
                        "background-image":
                          'url("/assets/images/payment-bank.webp")',
                        "background-position": "center center",
                      }}
                    />
                    <div
                      className="v-responsive__content"
                      style={{ width: "27px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column customer-support">
                <label className="footer-title">{t("CustomerSupportTitle")}</label>
                <div className="d-flex">
                  <div
                    aria-label
                    className="v-image v-responsive theme--light"
                    style={{ "max-height": "32px", "max-width": "32px" }}
                  >
                    <div
                      className="v-responsive__sizer"
                      style={{ "padding-bottom": "100%" }}
                    />
                    <div
                      className="v-image__image v-image__image--cover"
                      style={{
                        "background-image":
                          'url("/assets/images/icon-24hr.webp")',
                        "background-position": "center center",
                      }}
                    />
                    <div
                      className="v-responsive__content"
                      style={{ width: "51px" }}
                    />
                  </div>
                
                </div>
              </div>
              <div className="community">
                <div className="row mb-2 no-gutters">
                  <label className="footer-title">{t("Certifications")}</label>
                </div>
                <div className="row no-gutters">
                  <a href="#">
                    <img
                      height={32}
                      src="/static/image/footer/gaming_Casino_Analyzer.svg"
                      alt
                    />
                  </a>
                  <img
                    height={32}
                    src="/static/image/footer/gaming_iTechLabs.svg"
                    alt
                    className="ml-2"
                  />
                </div>
              </div>
              <div className="customer-support">
                <div className="footer-title mb-2">{t("CommunityWebsites")}</div>
                <div className="d-flex flex-wrap payment-methods-icons">
                  <div
                    aria-label
                    className="v-image v-responsive footer-icon theme--light"
                  >
                    <div
                      className="v-responsive__sizer"
                      style={{ "padding-bottom": "101.667%" }}
                    />
                    <div
                      className="v-image__image v-image__image--cover"
                      style={{
                        "background-image":
                          'url("/assets/images/safe2.webp")',
                        "background-position": "center center",
                      }}
                    />
                    <div
                      className="v-responsive__content"
                      style={{ width: "60px" }}
                    />
                  </div>
                  <div
                    aria-label
                    className="v-image v-responsive footer-icon theme--light"
                  >
                    <div
                      className="v-responsive__sizer"
                      style={{ "padding-bottom": "110.345%" }}
                    />
                    <div
                      className="v-image__image v-image__image--cover"
                      style={{
                        "background-image":
                          'url("/assets/images/safe1_2.webp")',
                        "background-position": "center center",
                      }}
                    />
                    <div
                      className="v-responsive__content"
                      style={{ width: "58px" }}
                    />
                  </div>
                  <img
                    height={32}
                    src="/static/image/footer/gaming_license.webp"
                    alt
                  />
                </div>
              </div>
              <div className>
                <div className="footer-title mb-2">{t("FollowUs")}</div>
                <div className="d-flex flex-wrap payment-methods-icons">
                  <img
                    height={32}
                    src="/static/image/footer/TELE.png"
                    alt
                    // onclick="window.open('https://t.me/winx9Officials', '_blank')"
                  />
                  <img
                    height={32}
                    src="/static/image/footer/FB.png"
                    alt
                    // onclick="window.open('https://facebook.com/winx9official', '_blank')"
                  />
                  <img
                    height={32}
                    src="/static/image/footer/IG.png"
                    alt
                    // onclick="window.open('https://www.instagram.com/winx9officials', '_blank')"
                  />
                  <img
                    height={32}
                    src="/static/image/footer/YT.png"
                    alt
                    // onclick="window.open('https://www.youtube.com/@winx9official', '_blank')"
                  />
                  <img
                    height={32}
                    src="/static/image/footer/X.png"
                    alt
                    // onclick="window.open('https://x.com/winx9Official', '_blank')"
                  />
                </div>
              </div>
            </div>
            <div className="py-5 col col-12">
              <hr
                role="separator"
                aria-orientation="horizontal"
                className="v-divider theme--light"
              />
            </div>
            <div className="seo_text text-left">
              {t("SeoText")}
            </div>
            <div className="py-2 col col-12">
              <hr
                role="separator"
                aria-orientation="horizontal"
                className="v-divider theme--light"
              />
            </div>
            <div className="row align-center cols no-gutters justify-space-between">
              <div className="row mb-2 no-gutters">
                <img
                  src="../../assets/images/logo.png"
                  alt="winx9 cricket exchange"
                  className="footer-logo"
                  style={{
                    "-ms-flex-item-align": "end",
                    "align-self": "end",
                  }}
                />
                <hr
                  role="separator"
                  aria-orientation="vertical"
                  className="footer-divider ml-5 v-divider v-divider--vertical theme--light"
                  style={{ display: "none" }}
                />
              </div>
              <div className="faq-container no-gutters col-md-4 col-12">
                <div className="row faq-wrapper">
                  <a href="#" className="footer-title">
                    {t("ResponsibleGaming")}
                  </a>
                  <a href="#"  className="footer-title">
                    {t("TERMANDCONDITIO")}
                  </a>
                  <a href="#" className="footer-title">
                    {t("ABOUTUS")}
                  </a>
                </div>
                <div
                  className="copyright"
                  style={{ color: "var(--v-description-darken3)" }}
                >
                  {t("FooterCopyright")}
                </div>
              </div>
            </div>
          </div>
        </footer>
  )
}

export default FooterNew